var unitTaskStatuses = [
  { label: 'رزرو شده', value: -1 },
  { label: 'لغو رزرو', value: -2 },
  { label: 'سفارشات جدید', value: 0 },
  { label: 'ارجاع شده', value: 1 },
  { label: 'در حال انجام', value: 2, userType: 3 },
  { label: 'درخواست تغییر مواد اولیه', value: 10 },
  { label: 'تکمیل شده', value: 3 },
  { label: 'لغو شده', value: 5 }
]

export default unitTaskStatuses
